import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class AuthRequestSample extends Component {
    getOrderId() {
        const { order_id, selectedProgLangId } = this.props;
        if(order_id === "none") {
            switch(selectedProgLangId) {
                case _DOTNET:
                    return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
                case _JAVA:
                    return `"Test"+createDate.getTime()`;
                case _PHP:
                    return `'ord-'.date("dmy-G:i:s")`;
                default:
                    return "";
            }
        }
        else
            return `"${order_id}"`;
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    render() {
        const { storeId, apiToken, pan, expdate, amount, currency, selectedProgLangId } = this.props;

        switch(selectedProgLangId) {
            case _DOTNET:
                return (
                    <pre className="sampleCode">
{`using System;
using Moneris;

public class TestCanadaMpiThreeDSAuthentication
{
 public static void Main(string[] args)
 {
  string store_id = "`}{this.getValue(storeId, "storeId")}{`";
  string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
		
  string processing_country_code = "CA";
  MpiThreeDSAuthentication mpiThreeDSAuthentication = new MpiThreeDSAuthentication();

  mpiThreeDSAuthentication.SetOrderId(${this.getOrderId()});
  //must be the same one that was used in MpiCardLookup call

  mpiThreeDSAuthentication.SetCardholderName("Moneris Test");

  mpiThreeDSAuthentication.SetPan("`}{this.getValue(pan, "pan")}{`");
  mpiThreeDSAuthentication.SetExpdate("`}{this.getValue(expdate, "expdate")}{`"); 
  mpiThreeDSAuthentication.SetAmount("`}{this.getValue(amount, "amount")}{`");

  mpiThreeDSAuthentication.SetThreeDSCompletionInd("Y"); 
  //(Y|N|U) indicates whether 3ds method MpiCardLookup 
  was successfully completed

  mpiThreeDSAuthentication.SetRequestType("01");
  //(01=payment|02=recur)

  mpiThreeDSAuthentication.SetPurchaseDate("20200819035249");//(YYYYMMDDHHMMSS)

  mpiThreeDSAuthentication.SetNotificationURL("https://yournotificationurl.com"); 
  //(Website where response from RRes or CRes after challenge will go)

  mpiThreeDSAuthentication.SetChallengeWindowSize("03"); 
  //(01 = 250 x 400, 02 = 390 x 400, 03 = 500 x 600, 04 = 600 x 400, 05 = Full screen)
         
  mpiThreeDSAuthentication
  .SetBrowserUserAgent("Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.132 Safari/537.36\\");
  
  mpiThreeDSAuthentication.SetBrowserJavaEnabled("true"); //(true|false)

  mpiThreeDSAuthentication.SetBrowserScreenHeight("1000");
  //(pixel height of cardholder screen)

  mpiThreeDSAuthentication.SetBrowserScreenWidth("1920");
  //(pixel width of cardholder screen)

  mpiThreeDSAuthentication.SetBrowserLanguage("en-GB");
  //(defined by IETF BCP47)
        
  //Optional Methods
  mpiThreeDSAuthentication.SetCurrency("`}{this.getValue(currency, "currency")}{`");
  mpiThreeDSAuthentication.SetBillAddress1("3300 Bloor St W");
  mpiThreeDSAuthentication.SetBillProvince("ON");
  mpiThreeDSAuthentication.SetBillCity("Toronto");
  mpiThreeDSAuthentication.SetBillPostalCode("M8X 2X2");
  mpiThreeDSAuthentication.SetBillCountry("124");
        
  mpiThreeDSAuthentication.SetShipAddress1("3300 Bloor St W");
  mpiThreeDSAuthentication.SetShipProvince("ON");
  mpiThreeDSAuthentication.SetShipCity("Toronto");
  mpiThreeDSAuthentication.SetShipPostalCode("M8X 2X2");
  mpiThreeDSAuthentication.SetShipCountry("124");

  mpiThreeDSAuthentication.SetEmail("test@email.com");
  mpiThreeDSAuthentication.SetRequestChallenge("Y"); 
  //(Y|N Requesting challenge regardless of outcome)

  HttpsPostRequest mpgReq = new HttpsPostRequest();
  mpgReq.SetProcCountryCode(processing_country_code);
  mpgReq.SetTestMode(true); 
  //false or comment out this line for production transactions

  mpgReq.SetStoreId(store_id);
  mpgReq.SetApiToken(api_token);
  mpgReq.SetTransaction(mpiThreeDSAuthentication);
  mpgReq.Send();


  /*******************  REQUEST  ********************/

  try
  {
   Receipt receipt = mpgReq.GetReceipt();

   Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
   Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
   Console.WriteLine("Message = " + receipt.GetMessage());
   Console.WriteLine("MessageType = " + receipt.GetMpiMessageType());
   Console.WriteLine("TransStatus = " + receipt.GetMpiTransStatus());
   Console.WriteLine("ChallengeURL = " + receipt.GetMpiChallengeURL());
   Console.WriteLine("ChallengeData = " + receipt.GetMpiChallengeData());
   Console.WriteLine("ThreeDSServerTransID = " + receipt.GetMpiThreeDSServerTransID());
   
   //In Frictionless flow, you may receive TransStatus as "Y",
   //in which case you can then proceed directly to Cavv Purchase/Preauth with values below

   if(receipt.GetMpiTransStatus().Equals("Y"))
   {
    Console.WriteLine("Cavv = " + receipt.GetMpiCavv());
    Console.WriteLine("ECI = " + receipt.GetMpiEci());
   }
  }
  catch (Exception e)
  {
   Console.WriteLine(e);
  }
 }
}
`}
                </pre>)

        case _JAVA:
            return (
                <pre className="sampleCode">
{`package Canada;

import JavaAPI.*;

public class TestCanadaMpiThreeDSAuthentication
 { 
  public static void main(String[] args)
  { 
   String store_id = "`}{this.getValue(storeId, "storeId")}{`";
   String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
   String processing_country_code = "CA";
   MpiThreeDSAuthentication mpiThreeDSAuthentication = new MpiThreeDSAuthentication();

   mpiThreeDSAuthentication.setOrderId(${this.getOrderId()}); 
   //must be the same one that was used in MpiCardLookup call.

   mpiThreeDSAuthentication.setCardholderName("Moneris Test");
   mpiThreeDSAuthentication.setPan("`}{this.getValue(pan, "pan")}{`");
   //mpiThreeDSAuthentication.setDataKey("8OOXGiwxgvfbZngigVFeld9d2"); 
   //Optional-For Moneris Vaultand Hosted Tokenization tokens in place of setPan

   mpiThreeDSAuthentication.setExpdate("`}{this.getValue(expdate, "expdate")}{`");
   mpiThreeDSAuthentication.setAmount("`}{this.getValue(amount, "amount")}{`");
   mpiThreeDSAuthentication.setThreeDSCompletionInd("Y"); 
   //(Y|N|U) indicates whether 3ds method MpiCardLookup was successfully completed

   mpiThreeDSAuthentication.setRequestType("01"); //(01=payment|02=recur)
   mpiThreeDSAuthentication.setPurchaseDate("20200819035249"); //(YYYYMMDDHHMMSS)
   mpiThreeDSAuthentication.setNotificationURL("https://yournotificationurl.com"); 
   //(Website where response from RRes or CRes after challenge will go)

   mpiThreeDSAuthentication.setChallengeWindowSize("03"); 
   //(01 = 250 x 400, 02 = 390 x 400, 03 = 500 x 600, 04 = 600 x 400, 05 = Full screen)
   mpiThreeDSAuthentication.setBrowserUserAgent("Mozilla/5.0 (Windows NT 10.0; Win64; x64)
   AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.132 Safari/537.36\\");
   mpiThreeDSAuthentication.setBrowserJavaEnabled("true"); //(true|false)
   mpiThreeDSAuthentication.setBrowserScreenHeight("1000"); //(pixel height of cardholder screen)
   mpiThreeDSAuthentication.setBrowserScreenWidth("1920"); //(pixel width of cardholder screen)
   mpiThreeDSAuthentication.setBrowserLanguage("en-GB"); //(defined by IETF BCP47)

   //Optional Methods
   mpiThreeDSAuthentication.setCurrency("`}{this.getValue(currency, "currency")}{`");
   mpiThreeDSAuthentication.setBillAddress1("3300 Bloor St W");
   mpiThreeDSAuthentication.setBillProvince("ON");
   mpiThreeDSAuthentication.setBillCity("Toronto");
   mpiThreeDSAuthentication.setBillPostalCode("M8X 2X2");
   mpiThreeDSAuthentication.setBillCountry("124");
   mpiThreeDSAuthentication.setShipAddress1("3300 Bloor St W");
   mpiThreeDSAuthentication.setShipProvince("ON");
   mpiThreeDSAuthentication.setShipCity("Toronto");
   mpiThreeDSAuthentication.setShipPostalCode("M8X 2X2");
   mpiThreeDSAuthentication.setShipCountry("124");
   mpiThreeDSAuthentication.setEmail("test@email.com");
   mpiThreeDSAuthentication.setRequestChallenge("Y"); 
   //(Y|N Requesting challenge regardless of outcome)

   //******************OPTIONAL VARIABLES*******************
   HttpsPostRequest mpgReq = new HttpsPostRequest();
   mpgReq.setProcCountryCode(processing_country_code);
   mpgReq.setTestMode(true); 
   //false or comment out this line for production transactions

   mpgReq.setStoreId(store_id);
   mpgReq.setApiToken(api_token);
   mpgReq.setTransaction(mpiThreeDSAuthentication);
   mpgReq.send();

   /********************** REQUEST ************************/
   try
   { 
    Receipt receipt = mpgReq.getReceipt();
    System.out.println("ResponseCode = " + receipt.getResponseCode());
    System.out.println("ReceiptId = " + receipt.getReceiptId());
    System.out.println("Message = " + receipt.getMessage());
    System.out.println("MessageType = " + receipt.getMpiMessageType());
    System.out.println("TransStatus = " + receipt.getMpiTransStatus());
    System.out.println("ChallengeURL = " + receipt.getMpiChallengeURL());
    System.out.println("ChallengeData = " + receipt.getMpiChallengeData());
    System.out.println("ThreeDSServerTransId = " + receipt.getMpiThreeDSServerTransId());
    
    //In Frictionless flow, you may receive TransStatus as "Y", 
    //in which case you can then proceed directly to Cavv Purchase/Preauth with values below

    if(receipt.getMpiTransStatus().equals("Y"))
    {
     System.out.println("Cavv = " + receipt.getMpiCavv());
     System.out.println("ECI = " + receipt.getMpiEci());
    }
   } 
   catch (Exception e)
   { 
    e.printStackTrace();
   }
  }
}
`}
                </pre>
            )

        case _PHP:
            return (
                <pre className="sampleCode">
{`<?php

require "../../mpgClasses.php";

/******************** Request Variables *****************/
$store_id = "`}{this.getValue(storeId, "storeId")}{`";
$api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
$mpiThreeDSAuthentication = new MpiThreeDSAuthentication();
$mpiThreeDSAuthentication->setOrderId(${this.getOrderId()}); 
//must be the same one that was used in MpiCardLookup call

$mpiThreeDSAuthentication->setCardholderName("Moneris Test");
$mpiThreeDSAuthentication->setPan("`}{this.getValue(pan, "pan")}{`");
//$mpiThreeDSAuthentication->setDataKey("8OOXGiwxgvfbZngigVFeld9d2"); 
//Optional - For Moneris Vault and Hosted Tokenization tokens in place of setPan

$mpiThreeDSAuthentication->setExpdate("`}{this.getValue(expdate, "expdate")}{`");
$mpiThreeDSAuthentication->setAmount("`}{this.getValue(amount, "amount")}{`");
$mpiThreeDSAuthentication->setThreeDSCompletionInd("Y"); 
//(Y|N|U) indicates whether 3ds method MpiCardLookup was successfully completed
$mpiThreeDSAuthentication->setRequestType("01"); //(01=payment|02=recur)
$mpiThreeDSAuthentication->setPurchaseDate("20200911035249"); //(YYYYMMDDHHMMSS)
$mpiThreeDSAuthentication->setNotificationURL("https://yournotificationurl.com"); 
//(Website where response from RRes or CRes after challenge will go)

$mpiThreeDSAuthentication->setChallengeWindowSize("03"); 
//(01 = 250 x 400, 02 = 390 x 400, 03 = 500 x 600, 04 = 600 x 400, 05 = Full screen)
$mpiThreeDSAuthentication->setBrowserUserAgent("Mozilla/5.0 (Windows NT 10.0; Win64; x64)
AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.132 Safari/537.36\\");
$mpiThreeDSAuthentication->setBrowserJavaEnabled("true"); //(true|false)
$mpiThreeDSAuthentication->setBrowserScreenHeight("1000"); //(pixel height of cardholder screen)
$mpiThreeDSAuthentication->setBrowserScreenWidth("1920"); //(pixel width of cardholder screen)
$mpiThreeDSAuthentication->setBrowserLanguage("en-GB"); //(defined by IETF BCP47)

//Optional Methods
$mpiThreeDSAuthentication->setCurrency("`}{this.getValue(currency, "currency")}{`");
$mpiThreeDSAuthentication->setBillAddress1("3300 Bloor St W");
$mpiThreeDSAuthentication->setBillProvince("ON");
$mpiThreeDSAuthentication->setBillCity("Toronto");
$mpiThreeDSAuthentication->setBillPostalCode("M8X 2X2");
$mpiThreeDSAuthentication->setBillCountry("124");
$mpiThreeDSAuthentication->setShipAddress1("3300 Bloor St W");
$mpiThreeDSAuthentication->setShipProvince("ON");
$mpiThreeDSAuthentication->setShipCity("Toronto");
$mpiThreeDSAuthentication->setShipPostalCode("M8X 2X2");
$mpiThreeDSAuthentication->setShipCountry("124");
$mpiThreeDSAuthentication->setEmail("test@email.com");
$mpiThreeDSAuthentication->setRequestChallenge("Y"); 
//(Y|N Requesting challenge regardless of outcome)

/****************** Transaction Object *********************/
$mpgTxn = new mpgTransaction($mpiThreeDSAuthentication);

/******************* Request Object ***********************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions

/****************** HTTPS Post Object ********************/
$mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest);

/********************** Response ************************/
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nReceiptId = " . $mpgResponse->getReceiptId());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nMessageType = " . $mpgResponse->getMpiMessageType());
print("\\nTransStatus = " . $mpgResponse->getMpiTransStatus());
print("\\nChallengeURL = " . $mpgResponse->getMpiChallengeURL());
print("\\nChallengeData = " . $mpgResponse->getMpiChallengeData());
print("\\nThreeDSServerTransId = " . $mpgResponse->getMpiThreeDSServerTransId());

//In Frictionless flow, you may receive TransStatus as "Y", 
//in which case you can then proceed directly to Cavv Purchase/Preauth with values below'

if($mpgResponse->getMpiTransStatus() == "Y")
{
 print("\\nCavv = " . $mpgResponse->getMpiCavv());
 print("\\nECI = " . $mpgResponse->getMpiEci());
}
?>
`}
                </pre>
            )
        default:
            return null
        }
    }
}

const mapStateToProps = state => {
  const { storeId, apiToken, order_id, pan, expdate, amount, currency, onEditId } = state.threeDSTwo.main.config;
  const { selection } = state.common.progLangList;
  return { storeId, apiToken, order_id, pan, expdate, amount, currency, selectedProgLangId: selection, onEditId };
}

export default connect(mapStateToProps, {})(AuthRequestSample)
